import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=5d55045a&scoped=true&"
import script from "./BookingCard.vue?vue&type=script&lang=js&"
export * from "./BookingCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=5d55045a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55045a",
  null
  
)

export default component.exports